var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 20,
    height: 14,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M-2.8e-7 12.25c0-2.32999992 4.66000366-3.5 7-3.5s7 1.17000008 7 3.5V14h-14v-1.75zm7-1.5c-1.63417053.01501942-3.23770141.44515228-4.66000366 1.25h9.32000732c-1.42230224-.80484772-3.02584838-1.23498058-4.66000366-1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M10.49999972 3.5c0 1.93299675-1.56700134 3.5-3.5 3.5-1.93299865 0-3.5-1.56700325-3.5-3.5s1.56700135-3.5 3.5-3.5c1.93299866 0 3.5 1.56700325 3.5 3.5zm-2 0c0-.82842731-.67156982-1.5-1.5-1.5-.82843017 0-1.5.67157269-1.5 1.5s.67156983 1.5 1.5 1.5c.82843018 0 1.5-.67157269 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M14.04 8.81c1.18764685.74659822 1.9232506 2.03765787 1.96 3.44V14h4v-1.75c0-2.02-3.5-3.17-5.96-3.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M13 7c1.93299662 0 3.5-1.56700338 3.5-3.5S14.93299662 0 13 0c-.52000336.00199604-1.03281223.12165144-1.5.35 1.33340806 1.88833607 1.33340806 4.41166393 0 6.3.46718777.22834856.97999664.34800396 1.5.35z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientes);
export default __webpack_public_path__ + "static/media/clientes.7b9e79cb781f36bc4dc5a448fe4139f0.svg";
export { ForwardRef as ReactComponent };